import { Api } from '@/api/api';
import { CustomerExperienceAppointmentDashboardRequest } from '@/api/requests/dashboard/customer-experience-appointment-dashboard-request';
import { CustomerExperienceCallDashboardRequest } from '@/api/requests/dashboard/customer-experience-call-dashboard-request';
import { DataCreationDashboardRequest } from '@/api/requests/dashboard/data-creation-dashboard-request';
import { PartnerPracticeDashboardRequest } from '@/api/requests/dashboard/partner-practice-dashboard-request';
import { TaskDashboardRequest } from '@/api/requests/dashboard/task-dashboard-request';
import { CustomerExperienceAppointmentDashboardResponse } from '@/api/responses/dashboard/customer-experience-appointment-dashboard-response';
import { CustomerExperienceCallDashboardResponse } from '@/api/responses/dashboard/customer-experience-call-dashboard-response';
import { DataCreationDashboardResponse } from '@/api/responses/dashboard/data-creation-dashboard-response';
import { PartnerPracticeDashboardResponse } from '@/api/responses/dashboard/partner-practice-dashboard-response';
import { TaskDashboardResponse } from '@/api/responses/dashboard/task-dashboard-response';

export class DashboardApi extends Api {
    public getPartnerPracticeDashboardDataAsync(filters: PartnerPracticeDashboardRequest): Promise<PartnerPracticeDashboardResponse> {
        return this.getAsync<PartnerPracticeDashboardResponse>(`v1/dashboard/partnerpractice`, filters);
    }

    public getCustomerExperienceAppointmentDashboardDataAsync(filters: CustomerExperienceAppointmentDashboardRequest): Promise<CustomerExperienceAppointmentDashboardResponse> {
        return this.getAsync<CustomerExperienceAppointmentDashboardResponse>(`v1/dashboard/customerexperience/appointment`, filters);
    }

    public getCustomerExperienceCallDashboardDataAsync(filters: CustomerExperienceCallDashboardRequest): Promise<CustomerExperienceCallDashboardResponse> {
        return this.getAsync<CustomerExperienceCallDashboardResponse>(`v1/dashboard/customerexperience/call`, filters);
    }

    public getDataCreationDashboardDataAsync(filters: DataCreationDashboardRequest): Promise<DataCreationDashboardResponse> {
        return this.getAsync<DataCreationDashboardResponse>(`v1/dashboard/datacreation`, filters);
    }

    public getTaskDashboardDataAsync(filters: TaskDashboardRequest): Promise<TaskDashboardResponse> {
        return this.getAsync<TaskDashboardResponse>(`v1/dashboard/task`, filters);
    }

    public constructor() {
        super();
    }
}
